import { defineComponent as _defineComponent } from 'vue'
import bugsnagClient from 'JS/global/bugsnag';
import ConnectRewardsForm from './ConnectRewardsForm.vue';
import EnterVerificationCode from './EnterVerificationCode.vue';
import JoinRewardsForm from './JoinRewardsForm.vue';
import RewardsGetHelp from './RewardsGetHelp.vue';
import RewardsSuccess from './RewardsSuccess.vue';
import UserVerification from './UserVerification.vue';
import windowData from 'JS/global/window-data';
import { CreateOauthAccountRequest, ICreateAccountResource, IGetRewardsDataResponse } from 'JS/types/Account';
import { onBeforeMount, ref } from 'vue';
import { delay } from 'JS/utilities/promise';
import { EnterCodeVariant, IJoinRewardsStep, IVerifyUserData } from 'JS/types/rewards';
import { provideDefaultInputLabelVariant } from 'JS/components/blain-form/input-label-variant';
import { serviceRegistry } from '../../composables/services';


export default /*#__PURE__*/_defineComponent({
  __name: 'RewardsSideMenuContents',
  props: {
    step: null,
    verificationData: null,
    createAccountRequest: null,
    createOauthAccountRequest: null
  },
  emits: ["close", "force-reload", "loading", "update:step", "update-side-menu-header-button", "anti-forgery-token"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'close'): void,
	(e: 'force-reload'): void,
	(e: 'loading', value: boolean): void,
	(e: 'update:step', value: IJoinRewardsStep): void,
	(e: 'update-side-menu-header-button', returnPage: IJoinRewardsStep | "clear"): void
	(e: 'anti-forgery-token', token: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	step: IJoinRewardsStep,
	verificationData?: IVerifyUserData,
	createAccountRequest?: ICreateAccountResource,
	createOauthAccountRequest?: CreateOauthAccountRequest,
}






const { accountService } = serviceRegistry;
const { getAntiForgeryToken } = serviceRegistry;
provideDefaultInputLabelVariant('inline');

const antiForgeryToken = ref<string>("");
const checkingForRewards = ref<boolean>(true);
const isConnection = ref<boolean>(false);
const enterCodeVariant = ref<EnterCodeVariant>();
const enterCodeRedactedString = ref<string>();
const rewardsSessionId = ref<string>();
const userVerificationData = ref<IVerifyUserData>();
const joinRewardsErrorMessage = ref<string>();
const customer = windowData.customer;
const email = customer?.email ?? "";

function handleSwitchPage(page: IJoinRewardsStep, data?: IVerifyUserData) {
	let pageToReturnTo: IJoinRewardsStep | "clear" = "clear";

	if (page === 'connect' && props.step === 'join') {
		pageToReturnTo = 'join';
	} else if (page === 'success' || page === 'customer-has-rewards') {
		isConnection.value = props.step !== 'join';
		pageToReturnTo = 'clear';
		emit('force-reload');
	} else if (page.includes('verification') || page === 'account-in-use') {
		userVerificationData.value = data;
		if (page !== 'verification-account') {
			pageToReturnTo = props.step;
		}
	} else if (page === 'enter-code' || page === 'help') {
		pageToReturnTo = props.step;
	}

	emit('update-side-menu-header-button', pageToReturnTo);
	emit('update:step', page);
}

function handleGoToEnterCode(variant: EnterCodeVariant, redactedString?: string, rewardSesId?: string) {
	if (variant === 'rewards-number') {
		enterCodeRedactedString.value = null;
	} else {
		enterCodeRedactedString.value = redactedString;
	}
	enterCodeVariant.value = variant;
	rewardsSessionId.value = rewardSesId;
	handleSwitchPage('enter-code');
}

function handleIsLoading(value: boolean) {
	emit('loading', value);
}

//Pre-loads the sidemenus images to the cache upon opening the sidemenu.
function preloadImages() {
	const img = new Image().src = "/assets/images/rewards/security-verification-lock.jpg";
	const img2 = new Image().src = "/assets/images/rewards/enter-code-lock.jpg";
	const img3 = new Image().src = "/assets/images/rewards/get-help-header-image.jpg";
}

async function checkForRewards() {
	try {
		emit('loading', true);
		const results: IGetRewardsDataResponse = await accountService.getRewardsData();

		if (results) {
			if (results.success) {
				if (results.emailAlreadyLinked) {
					joinRewardsErrorMessage.value = "<span class='bold'>Sorry! Your email is connected to another account.</span> To resolve call Customer Service at <a class='black' href='tel:+1-800-210-2370'>1-800-210-2370</a>.";
					emit('update:step', 'join');
				} else if (results.sessionMFound) {
					userVerificationData.value = { phone: results.phone, email: results.email, variant: 'verification-join', redactedData: 'phone' };
					emit('update:step', 'verification-account');
				}
			} else {
				if (results.customerHasRewards) {
					emit('force-reload');
					emit('close');
				} else {
					bugsnagClient.notify(new Error("Customer object not found when attempting to get rewards data."));
					window.location.reload();
				}
			}
		}

		emit('loading', false);
	} catch (err) {
		bugsnagClient.notify(err);
		window.location.reload();
	}
}

onBeforeMount(async ()=> {
	emit('loading', true);
	preloadImages();
	if (props.step === 'verification-join') {
		userVerificationData.value = props.verificationData;
	} else if (props.step !== 'success') {
		await delay(checkForRewards(), 400);
	}
	checkingForRewards.value = false;
	antiForgeryToken.value = await delay(getAntiForgeryToken(), 400);
	emit('anti-forgery-token', antiForgeryToken.value);
	emit('loading', false);
});


return { __sfc: true,props, emit, accountService, getAntiForgeryToken, antiForgeryToken, checkingForRewards, isConnection, enterCodeVariant, enterCodeRedactedString, rewardsSessionId, userVerificationData, joinRewardsErrorMessage, customer, email, handleSwitchPage, handleGoToEnterCode, handleIsLoading, preloadImages, checkForRewards, ConnectRewardsForm, EnterVerificationCode, JoinRewardsForm, RewardsGetHelp, RewardsSuccess, UserVerification }
}

})